var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['loading-modal', 'loading', {'open': _vm.visible}]},[_c('LoadingIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }